<template lang="pug">
section.app-main(style='min-height: 100%')
  transition(name='fade', mode='out-in')
    router-view
</template>

<script>
export default {
  name: 'BaseLayoutTheAppMain'
}
</script>



// WEBPACK FOOTER //
// src/components/Base/Layout/TheAppMain/index.vue